export const SingleChannelBehavior = Object.freeze({
  OPEN_PICKER: 'open_picker',
  OPEN_CHANNEL: 'open_channel',
})
